import errorCodes from './error-codes'
import validation from './validation'

export default {
    errorCodes,
    validation
}
